module.exports = __webpack_public_path__ + "img/ic-nature.2c0c4f66.svg";